var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgConvergence1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9166_3542)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.60938 10.7891L17.1094 5.02344C18.4375 4.40625 19.4766 5.36719 18.8594 6.70312L13.1094 19.1406C12.5234 20.4219 10.8125 20.1641 10.8047 18.7812L10.7969 13.1719C10.7969 13.0938 10.7734 13.0703 10.6953 13.0703L5.04688 13.0469C3.70312 13.0391 3.375 11.3594 4.60938 10.7891ZM6.54688 11.5781L11.5547 11.5469C12.0469 11.5391 12.3047 11.8047 12.2969 12.2812L12.2656 17.3047C12.2656 17.3359 12.2969 17.3359 12.3125 17.3047L17.1562 6.75781C17.1875 6.69531 17.1562 6.67969 17.1016 6.69531L6.53906 11.5234C6.5 11.5391 6.50781 11.5781 6.54688 11.5781Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9166_3542"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConvergence1);
export default __webpack_public_path__ + "static/media/convergence1.dc8ec43bf89bd547c680a50139f27179.svg";
export { ForwardRef as ReactComponent };